<template>
    <div class="progress">
        <!--基本信息-->
        <span class="progress-item" :class="{active: stage === 1, complete: !not_finish_information}" @click="jump(1)">
            <span class="progress-word">{{getLabel('PROGRESS_1')}}</span>
            <span class="progress-tip first" v-if="stage === 1">{{getLabel('INFORMATION_GUIDE1')}}<span class="word-red">*</span>{{getLabel('INFORMATION_GUIDE2')}}</span>
        </span>
        <!--活动信息-->
        <span class="progress-line" :class="{active: activityLine}"></span>
        <span class="progress-item" :class="{active: stage === 2, complete: !not_finish_activity}" @click="jump(2)">
            <span class="progress-word">{{getLabel('PROGRESS_2')}}</span>
            <span class="progress-tip" v-if="stage === 2">{{getLabel('ACTIVITY_FAV')}}</span>
        </span>
        <!--航班信息-->
        <span class="progress-line" v-if="residence_city !== 1 && charge_type === 1" :class="{active: flightLine}"></span>
        <span class="progress-item" :class="{active: stage === 3, complete: flightIsFinish}" v-if="residence_city !== 1 && charge_type === 1" @click="jump(3)">
            <span class="progress-word">{{getLabel('PROGRESS_3')}}</span>
            <span class="progress-tip" v-if="stage === 3">{{getLabel('FLIGHT_GUIDE1')}}</span>
        </span>
        <!--酒店信息-->
        <span class="progress-line" v-if="residence_city !== 1" :class="{active: hotelLine}"></span>
        <span class="progress-item" :class="{active: stage === 4, complete: !not_finish_hotel}" v-if="residence_city !== 1" @click="jump(4)">
            <span class="progress-word">{{getLabel('PROGRESS_4')}}</span>
            <span class="progress-tip" v-if="stage === 4">{{getLabel('HOTEL_SUBTITLE')}}</span>
        </span>
        <!--注册成功-->
        <span class="progress-line" :class="{active: regSuccessLine}"></span>
        <span class="progress-item" :class="{active: stage === 5, complete: regSuccessLine}" @click="jump(5)">
            <span class="progress-word">{{getLabel('PROGRESS_5')}}</span>
        </span>
        <!--与会文件-->
        <span class="progress-line" v-if="is_lecture" :class="{active: docLine}"></span>
        <span class="progress-item" :class="{active: stage === 6, complete: !not_finish_document}" v-if="is_lecture" @click="jump(6)">
            <span class="progress-word">{{getLabel('PROGRESS_6')}}</span>
        </span>
    </div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
	import Language from '../util/language';
	import router from '../router';
	import {Modal} from 'ant-design-vue';

	export default {
		props: {
			'stage': {
				type: Number
            }
        },
		components: {},
		data() {
			return {}
		},
		mounted() {

		},
		computed: {
			...mapState({
				language: state => state.main.language,
				residence_city: state => state.main.currentUser.residence_city,  // 常住地，1 上海 0 非上海
				charge_type: state => state.main.currentUser.charge_type, // 费用类型，1：公费 2：自费 3：分论坛
				is_lecture: state => state.main.currentUser.is_lecture,
                flightIsFinish: state => state.flight.isFinish
			}),
			...mapGetters('main', {
				not_finish_information: 'not_finish_information'
			}),
            ...mapGetters('activity', {
                not_finish_activity: 'not_finish_activity'
            }),
            ...mapGetters('hotel', {
                not_finish_hotel: 'not_finish_hotel'
            }),
            ...mapGetters('document', {
                not_finish_document: 'not_finish_document'
            }),
            activityLine() {
                // 基本信息若展示，前面一定是基本信息
			    return !this.not_finish_information && !this.not_finish_activity;
            },
            flightLine() {
			    // 航班信息若展示，前面一定是活动信息
                return !this.not_finish_activity && this.flightIsFinish;
            },
            hotelLine() {
                if(this.charge_type === 1) {
                    // 公费：前一项为航班信息
                    return this.flightIsFinish && !this.not_finish_hotel;
                } else {
                    // 自费：前一项为活动信息
                    return !this.not_finish_activity && !this.not_finish_hotel;
                }
            },
            regSuccessLine() {
			    if(this.residence_city === 1) {
                    // 上海用户：基本信息 + 活动信息
                    return !this.not_finish_information && !this.not_finish_activity;
                } else {
			        // 非上海用户
                    if(this.charge_type === 1) {
                        // 公费： 基本信息 + 活动信息 + 航班信息 + 酒店信息
                        return !this.not_finish_information
                            && !this.not_finish_activity
                            && this.flightIsFinish
                            && !this.not_finish_hotel;
                    } else {
                        // 自费： 基本信息 + 活动信息 + 酒店信息
                        return !this.not_finish_information
                            && !this.not_finish_activity
                            && !this.not_finish_hotel;
                    }
                }
            },
            docLine() {
			    return this.regSuccessLine && !this.not_finish_document;
            }
 		},
		watch: {},
		methods: {
            // 获取描述
            getLabel: function (key) {
                return Language(this.language, key);
            },
            // 跳转
            jump: function (stage) {
                if (stage === this.stage) {
                	return;
                }
                // 注册成功不能直接跳转
                if (stage === 5) {
                    return;
                }
                let stageMap = {
                    1: '/information',
                    2: '/activity',
                    3: '/flight',
                    4: '/hotel',
                    5: '/regSuccess',
                    6: '/document'
                };
	            if (this.not_finish_information && stage !== 1) {
		            Modal.confirm({
			            iconType: 'info-circle',
			            title: this.getLabel('SUMMARY_CONFIRM'),
			            okText: this.getLabel('SUMMARY_CONFIRM_OK'),
			            cancelText: this.getLabel('TIP_CANCEL'),
			            onOk: () => {
				            this.$router.push(`${this.language === 'zh' ? '' : '/en'}/information`);
			            },
			            onCancel() {},
		            });
	            } else {
		            router.push(`${this.language === 'zh' ? '' : '/en'}${stageMap[stage]}`);
	            }
            }
		}
	};
</script>

<style lang="less" scoped>
    .progress {
        position: relative;
        width: 955px;
        height: 60px;
        line-height: 60px;
        margin: 0 auto;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &-item {
            cursor: pointer;
            color: #666;
            position: relative;
            width: 18px;
            height: 18px;
            background: url('../assets/img/grey-dot.png') center center no-repeat;
            background-size: 12px;
            margin: 0 10px;
            &.active, &:hover {
                color: #2099F3;
                background: url('../assets/img/blue-dot.png') center center no-repeat;
                width: 22px;
                height: 22px;
                background-size: 100%;
                .progress-word {
                    font-size: 18px;
                }
            }
            &.complete {
                color: #2099F3;
                background: url('../assets/img/selection.png') center center no-repeat;
                background-size: 100%;
            }
            &:nth-child(1) {
                margin-left: 0;
            }
            &:nth-last-child(1) {
                margin-right: 0;
            }
        }
        &-word {
            position: absolute;
            white-space: nowrap;
            left: 50%;
            top: -50px;
            transform: translateX(-50%);
        }
        &-tip {
            font-size: 14px;
            position: absolute;
            white-space: nowrap;
            left: 50%;
            top: 9px;
            transform: translateX(-50%);
        }
        &-line {
            width: 190px;
            height: 1px;
            background: #CCC;
            &.active {
                background: #2099F3;
            }
        }
    }
</style>
